import React from "react"
import WidthWrapper from "./WidthWrapper";
import theme from "../../../config/theme";

const ContentPanel = (props) => (
    <div className="content-panel-wrapper">
        <style jsx>{`
            .content-panel-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                
            }

            .content-panel {
                display: flex;
                flex-direction: column;
                width: 100%;
                flex-grow: 1;
                border-radius: 2px;

                ${props.narrow ? `max-width: 600px;` : ''}
                ${props.padded === false ? `` : 'padding: 20px;'}

                background-color: ${theme.colors.contentPanel.background};
                box-sizing: border-box;
                
                ${props.margin === false ? `` : `
                    margin-top: 30px;
                    margin-bottom: 20px;
                `}

            }

            @media only screen and (max-width: ${theme.responsive.m}px) {
                .content-panel {
                  
                    padding-bottom: 0px;
                    flex-grow: 1;
                    align-items: center;
                    margin: 0;
                    width: 100%;
                    max-width: 100%;
                    min-height: calc(100vh - 50px);
                }

                .content-panel-wrapper {
                    flex-grow: 1;
                }
            }

        `}</style>
        <div className="content-panel">
            {props.children}
        </div>
    </div>
)

export default ContentPanel;